export interface Gender {
  name: string;
  code: string;
}

export const genders: Array<Gender> = [
  { name: 'Male', code: 'MALE' },
  { name: 'Female', code: 'FEMALE' },
  { name: 'Unknown', code: 'UNKNOWN' },
];

export const getGenderName = (code: string) => {
  const gender = genders.find((g) => g.code === code);
  return gender && gender.name;
};

export const getGenderCode = (name: string) => {
  const gender = genders.find((g) => g.name === name);
  return gender && gender.code;
};
